import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { ButtonModule } from '@sb/library/button';
import { LayoutModule } from '@sb/library/layout';
import { CardComponent } from './card.component';
import { DataCardComponent } from './data-card/data-card.component';
import { EditableCardComponent } from './editable-card/editable-card.component';

@NgModule({
    declarations: [
        CardComponent,
        EditableCardComponent,
        DataCardComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        LayoutModule,
        MatDividerModule
    ],
    exports: [
        CardComponent,
        EditableCardComponent,
        DataCardComponent
    ]
})
export class CardModule { }
